import request from "@/utils/request";

export function getIndexInformation(params) {
  return request({
    url: "/index/index_information/get_default/",
    method: "get",
    params,
  });
}

export function getIndexRapidLinkList(params) {
  return request({
    url: "/index/index_rapid_links/",
    method: "get",
    params,
  });
}

export function getIndexBannerList(params) {
  return request({
    url: "/index/index_banners/",
    method: "get",
    params,
  });
}

export function getProductTypeList(params) {
  return request({
    url: "/index/index_product_types/",
    method: "get",
    params,
  });
}
